import React from "react";
import ReadingForm from "components/readingsAndAnamnesisForms/ReadingForm";
import ReadingsStore from "stores/ReadingsStore";

const ReadingFormSecondaryReadings = (props) => {
    const editingId = props.match.params.id;
    return <ReadingForm {...props} editingId={editingId} store={ReadingsStore} accessor={ReadingsStore.SECONDARY_READING_ACCESSOR} reroute={"/readings"} />;
};

export default ReadingFormSecondaryReadings;